import * as React from 'react';
import { getParentNode } from '../../../modules/studio/utils';
import { normalizeCssValue } from '../../../modules/utils';
import ModalAnimation from '../Animation/ModalAnimation';
import BackgroundAnimation from '../Animation/BackgroundAnimation';
import Button from '../../../components/common/Button/Button';
import { PortalContext } from '../Portal/Portal';
import { BaseModal } from '../BaseModal/BaseModal';
import cn from '~modules/cn';

import CloseIcon from '../../../assets/icons/v2design/basics/close.svg';

import './Modal.scss';

export const SKIP_CLOSE_CLASS = 'studio-modal--skip-close';

class ModalComponent extends React.Component {
    static defaultProps = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onBeforeClose: () => {},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClose: () => {},
        addDim: true,
        showCloseButton: true
    };

    animationElement: $TSFixMe;

    clickPosition: $TSFixMe;

    containerElement: $TSFixMe;

    contentElement: $TSFixMe;

    modalElement: $TSFixMe;

    state = {
        isClosing: true,
        modalResult: null
    };

    constructor(props: $TSFixMe) {
        super(props);
        this.modalElement = React.createRef();
        this.animationElement = React.createRef();
        this.containerElement = React.createRef();
        this.contentElement = React.createRef();
    }

    componentDidMount() {
        document.body.addEventListener('mousedown', this.handleMouseDown);
        document.body.addEventListener('mouseup', this.handleMouseUp);
        // @ts-expect-error TS(2339): Property 'setRef' does not exist on type 'Readonly... Remove this comment to see the full error message
        const { setRef } = this.props;
        if (typeof setRef === 'function') {
            setRef(this);
        } else if (setRef) {
            setRef.current = this;
        }
        void this.animationElement.current?.offsetTop;
        this.setState({ isClosing: false });
    }

    componentWillUnmount() {
        document.body.removeEventListener('mousedown', this.handleMouseDown);
        document.body.removeEventListener('mouseup', this.handleMouseUp);
    }

    handleMouseDown = (event: $TSFixMe) => {
        this.clickPosition = { x: event.pageX, y: event.pageY, target: event.target };
    };

    handleMouseUp = (event: $TSFixMe) => {
        if (!this.clickPosition) {
            return;
        }

        const { pageX, pageY } = event;
        const { x: clickX, y: clickY, target: clickTarget } = this.clickPosition;

        const moveDelta = 25;
        const movedAway = Math.abs(pageX - clickX) > moveDelta || Math.abs(pageY - clickY) > moveDelta;
        this.clickPosition = null;

        if (!this.modalElement.current || movedAway || clickTarget !== event.target) {
            return;
        }

        const shouldClose =
            !(
                this.modalElement.current.contains(event.target) ||
                event.target.classList?.contains(SKIP_CLOSE_CLASS) ||
                document.querySelector('#collaborator-role-dropdown-root')?.contains(event.target) ||
                Array.from(document.querySelectorAll('.tooltip')).some((element) => element.contains(event.target)) ||
                // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
                getParentNode(event.target, `.${SKIP_CLOSE_CLASS}`)
            ) ||
            // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
            getParentNode(event.target, '.studio-modal__close') ||
            // @ts-expect-error TS(2554): Expected 3 arguments, but got 2.
            getParentNode(event.target, '.studio-modal__custom_close') ||
            event.target === this.containerElement.current;

        if (shouldClose) {
            // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
            this.close();
        }
    };

    /**
     * Close the modal.
     * Sets isClosing to true so the modal starts fade out animation. When it's done - calls props.onClose
     */
    close = (modalResult: $TSFixMe) => {
        if (this.state.isClosing) {
            return;
        }
        // @ts-expect-error TS(2339): Property 'onBeforeClose' does not exist on type 'R... Remove this comment to see the full error message
        const result = this.props.onBeforeClose();
        if (result === false) {
            return;
        }
        this.setState({ isClosing: true, modalResult });
    };

    normalizeSpacing(spacing: $TSFixMe) {
        const normalizedSpacing = {};
        if (spacing.left !== undefined) {
            // @ts-expect-error TS(2339): Property 'left' does not exist on type '{}'.
            normalizedSpacing.left = spacing.left === '100vw' ? 0 : normalizeCssValue(spacing.left);
        } else if (spacing.right !== undefined) {
            // @ts-expect-error TS(2339): Property 'right' does not exist on type '{}'.
            normalizedSpacing.right = spacing.right === '100vw' ? 0 : normalizeCssValue(spacing.right);
        }

        if (spacing.bottom !== undefined) {
            // @ts-expect-error TS(2339): Property 'bottom' does not exist on type '{}'.
            normalizedSpacing.bottom = spacing.bottom === '100vh' ? 0 : normalizeCssValue(spacing.bottom);
        } else if (spacing.top !== undefined) {
            // @ts-expect-error TS(2339): Property 'top' does not exist on type '{}'.
            normalizedSpacing.top = spacing.top === '100vh' ? 0 : normalizeCssValue(spacing.top);
        }

        return normalizedSpacing;
    }

    onModalAnimationFinished = () => {
        // @ts-expect-error TS(2339): Property 'onClose' does not exist on type 'Readonl... Remove this comment to see the full error message
        const { onClose } = this.props;
        const { modalResult } = this.state;

        if (this.state.isClosing) {
            onClose(modalResult);
        }
    };

    render() {
        const {
            // @ts-expect-error TS(2339): Property 'useBaseModal' does not exist on type 'Re... Remove this comment to see the full error message
            useBaseModal,
            // @ts-expect-error TS(2339): Property 'resizableProps' does not exist on type '... Remove this comment to see the full error message
            resizableProps,
            // @ts-expect-error TS(2339): Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
            className = '',
            // @ts-expect-error TS(2339): Property 'showCloseButton' does not exist on type ... Remove this comment to see the full error message
            showCloseButton,
            // @ts-expect-error TS(2339): Property 'containerClassName' does not exist on ty... Remove this comment to see the full error message
            containerClassName,
            // @ts-expect-error TS(2339): Property 'fullScreen' does not exist on type 'Read... Remove this comment to see the full error message
            fullScreen,
            // @ts-expect-error TS(2339): Property 'topButtons' does not exist on type 'Read... Remove this comment to see the full error message
            topButtons,
            // @ts-expect-error TS(2339): Property 'left' does not exist on type 'Readonly<{... Remove this comment to see the full error message
            left,
            // @ts-expect-error TS(2339): Property 'right' does not exist on type 'Readonly<... Remove this comment to see the full error message
            right,
            // @ts-expect-error TS(2339): Property 'top' does not exist on type 'Readonly<{}... Remove this comment to see the full error message
            top,
            // @ts-expect-error TS(2339): Property 'bottom' does not exist on type 'Readonly... Remove this comment to see the full error message
            bottom,
            // @ts-expect-error TS(2339): Property 'addDim' does not exist on type 'Readonly... Remove this comment to see the full error message
            addDim,
            // @ts-expect-error TS(2339): Property 'dataTestId' does not exist on type 'Read... Remove this comment to see the full error message
            dataTestId,
            // @ts-expect-error TS(2339): Property 'error' does not exist on type 'Readonly<... Remove this comment to see the full error message
            error,
            // @ts-expect-error TS(2339): Property 'errorStr' does not exist on type 'Readon... Remove this comment to see the full error message
            errorStr
        } = this.props;
        const style = fullScreen
            ? {
                  left: 0,
                  right: 0,
                  top: 0,
                  bottom: 0
              }
            : this.normalizeSpacing({ left, right, top, bottom });
        // capture context for portals within the modal
        // @ts-expect-error TS(2339): Property 'children' does not exist on type 'Readon... Remove this comment to see the full error message
        const children = <PortalContext.Provider value={this.contentElement.current}>{this.props.children}</PortalContext.Provider>;
        // @ts-expect-error TS(2339): Property 'label' does not exist on type 'Readonly<... Remove this comment to see the full error message
        const modalTitle = this.props.label ?? (typeof this.props.Title === 'string' ? this.props.Title : undefined);
        return (
            <div className={cn('studio-modal', containerClassName)} data-testid={dataTestId}>
                <BackgroundAnimation
                    start="rgba(0, 0, 0, 0)"
                    end={addDim && 'rgba(0, 0, 0, 0.3)'}
                    active={!this.state.isClosing}
                    className="studio-modal__container"
                    style={style}
                    setRef={this.containerElement}
                >
                    <ModalAnimation
                        setRef={this.animationElement}
                        opened={!this.state.isClosing}
                        className="studio-modal__container-animation"
                        onAnimationFinished={this.onModalAnimationFinished}
                    >
                        <div className="studio-modal__wrapper" ref={this.modalElement} role="dialog" aria-modal="true" aria-label={modalTitle}>
                            {useBaseModal ? (
                                // explicitly pass props until all modal migrated to base modal
                                <div className={`studio-modal__content ${className}`}>
                                    <BaseModal
                                        // @ts-expect-error TS(2339): Property 'Title' does not exist on type 'Readonly<... Remove this comment to see message
                                        Title={this.props.Title}
                                        // @ts-expect-error TS(2339): Property 'Footer' does not exist on type 'Readonly... Remove this comment to see message
                                        Footer={this.props.Footer}
                                        // @ts-expect-error TS(2339): Property 'type' does not exist on type 'Readonly<{... Remove this comment to see message
                                        type={this.props.type}
                                        // @ts-expect-error TS(2339): Property 'size' does not exist on type 'Readonly<{... Remove this comment to see message
                                        size={this.props.size}
                                        // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
                                        onClose={() => this.close()}
                                        showCloseButton={showCloseButton}
                                        resizableProps={resizableProps}
                                        error={error}
                                        errorStr={errorStr}
                                        contentRef={this.contentElement}
                                    >
                                        {children}
                                    </BaseModal>
                                </div>
                            ) : (
                                <>
                                    <div className="studio-modal__top-buttons">
                                        {topButtons}
                                        {showCloseButton && (
                                            <Button
                                                className="studio-modal__close-button"
                                                buttonSize="small"
                                                icon={<CloseIcon />}
                                                buttonType="tertiary"
                                                // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
                                                onClick={() => this.close()}
                                            />
                                        )}
                                    </div>
                                    <div className={`studio-modal__content ${className}`} ref={this.contentElement}>
                                        {children}
                                    </div>
                                </>
                            )}
                        </div>
                    </ModalAnimation>
                </BackgroundAnimation>
            </div>
        );
    }
}

export default ModalComponent;
